export default {"src":"/fly/_next/static/media/user-card.87a47ac1.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};